export const OPEN_OCEAN_BASE_URL: string =
  "https://open-api.openocean.finance/";

export const TOP_TOKENS = ["BNB", "ETH", "DAI", "USDC", "USDT", "WBTC", "WETH"];

export const OPEN_OCEAN_CONTRACTS: any = {
  56: "0x6352a56caadC4F1E25CD6c75970Fa768A3304e64",
  137: "0x6352a56caadC4F1E25CD6c75970Fa768A3304e64",
  43114: "0x6352a56caadC4F1E25CD6c75970Fa768A3304e64",
};
